const ADMIN_BASE_PATH = '/admin';
const ROOT_BASE_PATH = '/';

export function resolveRouterBasename(pathname: string): string {
  return /^\/admin(?:\/|$)/.test(pathname) ? ADMIN_BASE_PATH : ROOT_BASE_PATH;
}
